<p-dialog [(visible)]="isVisible"  styleClass="hs-budget-dialog" [modal]="true" [style]="{ width: '1000px' }" [draggable]="false" [resizable]="false"(onHide)="cancel()">
    <ng-template pTemplate="header">
        <div class="dialog-header">
            <h3>Confirm budgets before sending to API</h3>
            <p>Review and edit budgets for all channels being sent.</p>
        </div>
    </ng-template>

    <div class="table-wrapper">
        <table class="hs-budget-table">
            <thead>
                <tr>
                    <th>CHANNEL</th>
                    <th>INVENTORY TYPE</th>
                    <th>FLIGHT NAME</th>
                    <th>DATES</th>
                    <th class="hs-budget-col">BUDGET</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of displayCreatives; let i = index" [class.unset-row]="row.budget === null || row.budget === 0">
                    <td>{{ enumChannelType[row.channelId] }}</td>
                    <td>{{ getInventoryName(row.creativeTypeId) }}</td>
                    <td>{{ row.name }}</td>
                    <td><div>{{ formatDate(row.flightStartDate) }} -</div>
                        <div>{{ formatDate(row.flightEndDate) }}</div></td>
                    <td class="hs-budget-col">
                        <div class="hs-budget-cell">

                            <!-- Normal View -->
                            <ng-container *ngIf="editingIndex !== i; else editMode">

                                <div style="gap: 2px; display: flex; flex-direction: column">
                                    <span class="hs-budget-value"
                                        [class.not-set]="row.budget == null">

                                        <ng-container *ngIf="row.budget != null && row.budget != 0; else notSet">
                                            <span class="hs-budget-amount">{{ row.budget | currency:'USD':'symbol':'1.0-0' }}</span>
                                        </ng-container>

                                        <ng-template #notSet>
                                            <label style="color: #b5521adb;">Not set</label>
                                        </ng-template>

                                    </span>

                                    <button
                                        pButton
                                        type="button"
                                        label="Edit"
                                        class="p-button-sm hs-edit-btn"
                                        (click)="editBudget(row,i)"
                                        [disabled]="isEditDisabled(row)">
                                    </button>
                                </div>
                            </ng-container>

                            <!-- Edit View -->
                            <ng-template #editMode>

                                <p-inputNumber
                                    [(ngModel)]="editableBudget"
                                    mode="currency"
                                    currency="USD"
                                    locale="en-US"
                                    [min]="0"
                                    [minFractionDigits]="0"
                                    [maxFractionDigits]="0"
                                    styleClass="hs-budget-input mr-2">
                                </p-inputNumber>

                                <div class="hs-edit-actions">

                                    <button
                                        pButton
                                        type="button"
                                        label="Save"
                                        class="p-button-primary p-button-sm hs-save-in-btn"
                                        (click)="saveBudget(row)">
                                    </button>

                                    <button
                                        pButton
                                        type="button"
                                        label="Cancel"
                                        class="flat-btn p-button-text p-button-sm hs-cancel-in-btn"
                                        (click)="cancelEdit()">
                                    </button>

                                </div>

                            </ng-template>

                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="hs-warning-box" *ngIf="hasUnsetBudgets">
        <i class="pi pi-exclamation-circle"></i>
        <span style="color: #75330d; margin-left: -10px;">One or more channels have no budget set. HUB will insert <span style="font-weight: bold;">$1</span> into the delivery platform for those channels. You can still proceed or set budgets above before sending.</span>
    </div>

    <ng-template pTemplate="footer">
        <div class="hs-dialog-footer">
            <button type="button" pButton class="flat-btn" label="Cancel" (click)="cancel()"></button>
            <button type="button" pButton class="p-button-primary save-send-btn" label="Save & Send to API" (click)="saveAndSend()"></button>
        </div>
    </ng-template>
</p-dialog>